import React, { useMemo } from 'react';
import Lottie from 'react-lottie';
import { useTheme } from 'styled-components';

import { useTranslation } from 'react-i18next';
import { applyThemeToLottie } from 'utils/lottie';
import novaLoadingAnimation from './nova-loading-animation.json';
import { LoadingContainer, LoadingIconContainer } from './styles';

function Loading() {
  const { t: translate } = useTranslation('chatbot');

  const theme = useTheme();
  const logoPrimary = theme.colors?.chatbot?.logo?.primary;
  const logoSecondary = theme.colors?.chatbot?.logo?.secondary;
  const logoTertiary = theme.colors?.chatbot?.logo?.tertiary;

  const animationData = useMemo(() => {
    if (!logoPrimary || !logoSecondary || !logoTertiary) {
      return novaLoadingAnimation;
    }

    return applyThemeToLottie(novaLoadingAnimation, {
      logoGradient: [logoPrimary, logoSecondary, logoTertiary],
      pulseFill: [logoPrimary, logoSecondary, logoPrimary, logoSecondary],
    });
  }, [logoPrimary, logoSecondary, logoTertiary]);

  return (
    <LoadingContainer>
      <LoadingIconContainer
        aria-label={translate('conversation.loading.a11y_label')}
      >
        <Lottie
          style={{ width: '100%', height: '100%' }}
          options={{
            loop: true,
            autoplay: true,
            animationData,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
          isClickToPauseDisabled={true}
        />
      </LoadingIconContainer>
    </LoadingContainer>
  );
}

export { Loading };
